/**
 * Geo rules for weight-loss *marketing* (GLP-1 landing, nav, promos).
 * Uses localStorage: `state`, `stateCode`, `countryCode` (from IP geo lookup in site.js).
 *
 * Indiana US: region name or state code IN — require country US when matching by code
 * (ISO country "IN" is India, not Indiana).
 */

export function isIndianaVisitor() {
    const country = (localStorage.getItem('countryCode') || '').trim().toLowerCase();
    const state = (localStorage.getItem('state') || '').trim().toLowerCase();
    const stateCode = (localStorage.getItem('stateCode') || '').trim().toLowerCase();
    return state === 'indiana' || (country === 'us' && stateCode === 'in');
}

export function shouldRestrictWeightLossMarketing() {
    return isIndianaVisitor();
}

export function shouldHideWeightLossHero() {
    return shouldRestrictWeightLossMarketing();
}

function hideAnchorOrParentRow(anchor) {
    const href = (anchor.getAttribute('href') || '').toLowerCase();
    if (href.includes('/update-semaglutide') || href.includes('/update-tirzepatide')) {
        return;
    }
    const row = anchor.closest('li');
    if (row) {
        row.style.display = 'none';
        return;
    }
    const cell = anchor.closest('.homeProductsWrapper__item, .thanksProductsWrapper > div');
    if (cell) {
        cell.style.display = 'none';
        return;
    }
    anchor.style.display = 'none';
}

export function applyHeroWeightSlideFallback() {
    if (!shouldHideWeightLossHero()) {
        return;
    }

    const carousel = document.querySelector('.hero-home .carousel');
    if (!carousel) {
        return;
    }

    let items;
    try {
        items = JSON.parse(carousel.getAttribute('data-hero-items') || '[]');
    } catch (e) {
        return;
    }

    const fallback = items.find(item => item.key !== 'weight');
    if (!fallback || !fallback['left-side-content']) {
        return;
    }

    const left = fallback['left-side-content'];
    const titleEl = carousel.querySelector('[data-hero-title]');
    const descEl = carousel.querySelector('[data-hero-description]');
    const linkEl = carousel.querySelector('[data-hero-link]');
    const linkTextEl = carousel.querySelector('[data-hero-link-text]');

    if (titleEl && left.title) {
        titleEl.textContent = left.title;
    }
    if (descEl && left.description) {
        descEl.textContent = left.description;
    }
    if (linkEl && left.link) {
        linkEl.setAttribute('href', left.link.url);
    }
    if (linkTextEl && left.link) {
        linkTextEl.textContent = left.link.text || 'Explore now';
    }

    carousel.querySelectorAll('.hero-navigation-item').forEach(nav => {
        if (nav.dataset.heroKey === 'weight') {
            nav.style.display = 'none';
            nav.classList.remove('active');
        } else if (fallback.key && nav.dataset.heroKey === fallback.key) {
            nav.classList.add('active');
        } else {
            nav.classList.remove('active');
        }
    });

}

/**
 * Hides weight-loss marketing across the storefront: nav, upsells, landing sections
 */
export function applyWeightLossMarketingRestrictions() {
    if (!shouldRestrictWeightLossMarketing()) {
        return;
    }

    document.body.classList.add('boldrx--hide-weight-marketing');

    document.querySelectorAll('.weight-loss-landing').forEach(el => {
        el.style.display = 'none';
    });

    document.querySelectorAll('a[href*="semaglutide-and-tirzepatide"]').forEach(a => {
        hideAnchorOrParentRow(a);
    });

    document.querySelectorAll('a.shop-weight-link').forEach(a => {
        hideAnchorOrParentRow(a);
    });

    document.querySelectorAll('.hero-navigation-item[data-hero-key="weight"]').forEach(el => {
        el.style.display = 'none';
    });

    document.querySelectorAll('.weight-loss-product').forEach(el => {
        el.style.display = 'none';
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/heroGeoRestriction.js